module.exports = __webpack_public_path__ + "img/logo-pasaz-grunwaldzki.23549c23.png";